import i18n from '@tecma/i18n';
import { useNavigate } from 'react-router-dom';

import { useStoreMobx } from 'mobx/helpers';

import { ENVIRONMENT } from 'constants/environment';

export const useExternalStoreData = () => {
  const store = useStoreMobx();
  const navigate = useNavigate();

  const externalStoreDataCalendar = {
    brokerId: store.brokerId || '',
    demoProjectId: store.demoProject?.id || '',
    projects: store.projects || [],
    loggedUser: store.loggedUser || {
      language: '',
      id: '',
      email: '',
      firstName: '',
      lastName: '',
      project_ids: [],
      role: '',
    },
    forceLogout: store.forceLogout,
    configLanguages: store.configLanguages as string[],
    name: store.name || '',
    i18n,
    externalEnvironment: ENVIRONMENT,
  };

  const externalStoreDataAccountManager = {
    brokerId: store.brokerId || '',
    demoProjectId: store.demoProject?.id || '',
    assets: store.projectsFilterOptions?.map((project) => ({ id: project.value, displayName: project.label })) || [],
    loggedUser: store.loggedUser || {
      language: '',
      id: '',
      email: '',
      firstName: '',
      lastName: '',
      project_ids: [],
      role: '',
    },
    forceLogout: store.forceLogout,
    onPermissionDeniedAction: () => {
      navigate('/');
    },
    languages: store.configLanguages as string[],
    name: store.name || '',
    i18n,
    externalEnvironment: ENVIRONMENT,
    projectArea: "sell"
  };

  return { externalStoreDataCalendar, externalStoreDataAccountManager };
};
